import types  from "../types/auth";
import { Login, User } from "../../models/LoginModel/login.model";
import { request_dispatch } from "../../utils";
import service from '../services';

export const user_token = (payload: User) => {
  return {
    type: types.USER_TOKEN,
    payload,
  };
};


const login = (data: Login) => request_dispatch(types.auth, service.login(data));


const actions = {
  login,

}

export default actions;